import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesCapacitaciones } from "./imagenesCapacitaciones";

function Revista() {
  return <PaginaPublica titulo="Capacitaciones" imagenes={imagenesCapacitaciones} />;
}

export default Revista;